// Class: starling.filters.DisplacementMapEffect

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_rendering_FilterEffect() {return require("./../../starling/rendering/FilterEffect");}
function starling_rendering_Program() {return require("./../../starling/rendering/Program");}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../openfl/_Vector/Vector_Impl_");}
function starling_utils_RenderUtil() {return require("./../../starling/utils/RenderUtil");}
function openfl_geom_Matrix3D() {return $import(require("openfl/geom/Matrix3D"));}
function starling_core_Starling() {return require("./../../starling/core/Starling");}
function Std() {return require("./../../Std");}

// Constructor

var DisplacementMapEffect = function() {
	(starling_rendering_FilterEffect().default).call(this);
	this._componentX = this._componentY = 0;
	this._scaleX = this._scaleY = 0;
	this._mapClamp = (openfl__$Vector_Vector_$Impl_$().default)._new(null,null,[0.0,0.0,1.0,1.0]);
}

// Meta

DisplacementMapEffect.__name__ = ["starling","filters","DisplacementMapEffect"];
DisplacementMapEffect.__super__ = (starling_rendering_FilterEffect().default);
DisplacementMapEffect.prototype = $extend((starling_rendering_FilterEffect().default).prototype, {
	createProgram: function() {
		if(this._mapTexture != null) {
			var vertexShader = ["m44  op, va0, vc0","mov  v0, va1","mov  v1, va2"].join("\n");
			var fragmentShaderLines = [];
			if(this.get_mapRepeatActual()) {
				fragmentShaderLines.push((starling_rendering_FilterEffect().default).tex("ft0","v1",1,this._mapTexture,false));
			} else {
				fragmentShaderLines = fragmentShaderLines.concat(["max ft4, v1, fc2","min ft4.xy, ft4.xy, fc2.zw",(starling_rendering_FilterEffect().default).tex("ft0","ft4",1,this._mapTexture,false)]);
			}
			fragmentShaderLines = fragmentShaderLines.concat(["sub ft1, ft0, fc0","mul ft1.xy, ft1.xy, ft0.ww","m44 ft2, ft1, fc3","add ft3,  v0, ft2","sat ft3.xy, ft3.xy","min ft3.xy, ft3.xy, fc1.xy",(starling_rendering_FilterEffect().default).tex("oc","ft3",0,this.get_texture())]);
			return (starling_rendering_Program().default).fromSource(vertexShader,fragmentShaderLines.join("\n"));
		} else {
			return (starling_rendering_FilterEffect().default).prototype.createProgram.call(this);
		}
	},
	beforeDraw: function(context) {
		(starling_rendering_FilterEffect().default).prototype.beforeDraw.call(this,context);
		if(this._mapTexture != null) {
			(openfl__$Vector_Vector_$Impl_$().default).set(DisplacementMapEffect.sInputClamp,0,this.get_texture().get_width() / this.get_texture().get_root().get_width() - 0.5 / this.get_texture().get_root().get_nativeWidth());
			(openfl__$Vector_Vector_$Impl_$().default).set(DisplacementMapEffect.sInputClamp,1,this.get_texture().get_height() / this.get_texture().get_root().get_height() - 0.5 / this.get_texture().get_root().get_nativeHeight());
			this.get_vertexFormat().setVertexBufferAt(2,this.get_vertexBuffer(),"mapTexCoords");
			context.setProgramConstantsFromVector("fragment",0,DisplacementMapEffect.sOffset);
			context.setProgramConstantsFromVector("fragment",1,DisplacementMapEffect.sInputClamp);
			context.setProgramConstantsFromVector("fragment",2,this._mapClamp);
			context.setProgramConstantsFromMatrix("fragment",3,DisplacementMapEffect.sMatrix,true);
			(starling_utils_RenderUtil().default).setSamplerStateAt(1,this._mapTexture.get_mipMapping(),this.get_textureSmoothing(),this.get_mapRepeatActual());
			context.setTextureAt(1,this._mapTexture.get_base());
		}
	},
	afterDraw: function(context) {
		if(this._mapTexture != null) {
			context.setVertexBufferAt(2,null);
			context.setTextureAt(1,null);
		}
		(starling_rendering_FilterEffect().default).prototype.afterDraw.call(this,context);
	},
	get_vertexFormat: function() {
		return DisplacementMapEffect.VERTEX_FORMAT;
	},
	get_programVariantName: function() {
		return (starling_rendering_FilterEffect().default).prototype.get_programVariantName.call(this) | (this.get_mapRepeatActual() ? 16 : 0);
	},
	getMapMatrix: function(out) {
		if(out == null) {
			out = new (openfl_geom_Matrix3D().default)();
		}
		var columnX;
		var columnY;
		var scale = (starling_core_Starling().default).get_current().get_contentScaleFactor();
		var textureWidth = this.get_texture().get_root().get_nativeWidth();
		var textureHeight = this.get_texture().get_root().get_nativeHeight();
		var _g = 0;
		while(_g < 16) {
			var i = _g++;
			(openfl__$Vector_Vector_$Impl_$().default).set(DisplacementMapEffect.sMatrixData,i,0);
		}
		if(this._componentX == 1) {
			columnX = 0;
		} else if(this._componentX == 2) {
			columnX = 1;
		} else if(this._componentX == 4) {
			columnX = 2;
		} else {
			columnX = 3;
		}
		if(this._componentY == 1) {
			columnY = 0;
		} else if(this._componentY == 2) {
			columnY = 1;
		} else if(this._componentY == 4) {
			columnY = 2;
		} else {
			columnY = 3;
		}
		(openfl__$Vector_Vector_$Impl_$().default).set(DisplacementMapEffect.sMatrixData,(Std().default)["int"](columnX * 4),this._scaleX * scale / textureWidth);
		(openfl__$Vector_Vector_$Impl_$().default).set(DisplacementMapEffect.sMatrixData,(Std().default)["int"](columnY * 4 + 1),this._scaleY * scale / textureHeight);
		out.copyRawDataFrom(DisplacementMapEffect.sMatrixData);
		return out;
	},
	get_mapRepeatActual: function() {
		if(this._mapRepeat) {
			return this._mapTexture.get_root().get_isPotTexture();
		} else {
			return false;
		}
	},
	clampMapTexCoords: function(xMin,yMin,xMax,yMax) {
		if(yMax == null) {
			yMax = 1.0;
		}
		if(xMax == null) {
			xMax = 1.0;
		}
		if(yMin == null) {
			yMin = 0.0;
		}
		if(xMin == null) {
			xMin = 0.0;
		}
		(openfl__$Vector_Vector_$Impl_$().default).set(this._mapClamp,0,xMin);
		(openfl__$Vector_Vector_$Impl_$().default).set(this._mapClamp,1,yMin);
		(openfl__$Vector_Vector_$Impl_$().default).set(this._mapClamp,2,xMax);
		(openfl__$Vector_Vector_$Impl_$().default).set(this._mapClamp,3,yMax);
	},
	get_componentX: function() {
		return this._componentX;
	},
	set_componentX: function(value) {
		return this._componentX = value;
	},
	get_componentY: function() {
		return this._componentY;
	},
	set_componentY: function(value) {
		return this._componentY = value;
	},
	get_scaleX: function() {
		return this._scaleX;
	},
	set_scaleX: function(value) {
		return this._scaleX = value;
	},
	get_scaleY: function() {
		return this._scaleY;
	},
	set_scaleY: function(value) {
		return this._scaleY = value;
	},
	get_mapTexture: function() {
		return this._mapTexture;
	},
	set_mapTexture: function(value) {
		return this._mapTexture = value;
	},
	get_mapRepeat: function() {
		return this._mapRepeat;
	},
	set_mapRepeat: function(value) {
		return this._mapRepeat = value;
	}
});
DisplacementMapEffect.prototype.__class__ = DisplacementMapEffect.prototype.constructor = $hxClasses["starling.filters.DisplacementMapEffect"] = DisplacementMapEffect;

// Init

Object.defineProperties(DisplacementMapEffect.prototype,{ "componentX" : { get : function () { return this.get_componentX (); }, set : function (v) { return this.set_componentX (v); }}, "componentY" : { get : function () { return this.get_componentY (); }, set : function (v) { return this.set_componentY (v); }}, "scaleX" : { get : function () { return this.get_scaleX (); }, set : function (v) { return this.set_scaleX (v); }}, "scaleY" : { get : function () { return this.get_scaleY (); }, set : function (v) { return this.set_scaleY (v); }}, "mapTexture" : { get : function () { return this.get_mapTexture (); }, set : function (v) { return this.set_mapTexture (v); }}, "mapRepeat" : { get : function () { return this.get_mapRepeat (); }, set : function (v) { return this.set_mapRepeat (v); }}});

// Statics


DisplacementMapEffect.VERTEX_FORMAT = (starling_rendering_FilterEffect().default).VERTEX_FORMAT.extend("mapTexCoords:float2")
DisplacementMapEffect.sOffset = (openfl__$Vector_Vector_$Impl_$().default)._new(null,null,[0.5,0.5,0.0,0.0])
DisplacementMapEffect.sInputClamp = (openfl__$Vector_Vector_$Impl_$().default)._new(null,null,[0.0,0.0,0.0,0.0])
DisplacementMapEffect.sMatrix = new (openfl_geom_Matrix3D().default)()
DisplacementMapEffect.sMatrixData = (openfl__$Vector_Vector_$Impl_$().default)._new(null,null,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.])

// Export

exports.default = DisplacementMapEffect;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/filters/DisplacementMapEffect.js
// module id = 323
// module chunks = 0